import { render, staticRenderFns } from "./ProductsConstructModal.vue?vue&type=template&id=3d633f9b&scoped=true&"
import script from "./ProductsConstructModal.vue?vue&type=script&lang=js&"
export * from "./ProductsConstructModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsConstructModal.vue?vue&type=style&index=0&id=3d633f9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d633f9b",
  null
  
)

component.options.__file = "ProductsConstructModal.vue"
export default component.exports